import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import styles from './NameField.module.scss'
import FieldError from '../../../JobPost/components/FieldError/FieldError';

function NameField({ form }) {
    const auth = useSelector((state) => state.auth);
    const [isDisabled, setDisabled] = useState(false)
    useEffect(() => {
        if (auth.user == undefined || auth.user.role == undefined)
            return;
        if (auth.user.role.includes('jobseeker'))
            setDisabled(true);

    }, [auth])
    return (
        <>
            <section className={`${styles.nameFieldWrapper} row`}>
                <div className={`${styles.title} col-md-3`}>
                    <h2>Full Name*</h2>
                </div>
                <div className={`${styles.inputWrapper} col-md-9`}>
                    <div className={styles.fieldWrap}>
                        <label htmlFor="full_name">Full Name*</label>
                    </div>
                    <input
                        id='full_name'
                        type="text"
                        name="full_name"
                        value={form.values.full_name}
                        onChange={form.handleChange}
                        disabled={isDisabled}
                    />
                    <FieldError error={form.errors.full_name} touched={form.touched.full_name} />
                </div>
                <div className={`${styles.inputWrapper} ${styles.email} col-md-9`}>
                    <div className={styles.fieldWrap}>
                        <label htmlFor="email">Email Address*</label>
                    </div>
                    <input
                        id='email'
                        name="email"
                        type="email"
                        value={form.values.email}
                        onChange={form.handleChange}
                        disabled={isDisabled}
                    />
                    <FieldError error={form.errors.email} touched={form.touched.email} />
                </div>
            </section>
        </>
    )
}

export default NameField
